module.exports = __webpack_public_path__ + "static/fonts/gothambold.7ec4fea.woff2";